<script>
import Vue from 'vue'

// resources
import EntitiesResource from '../../resources/entities'
import ProjectLocationResource from '../../resources/projectLocation'
import AgreementEntityResource from '../../resources/agreementEntity'
import CustomDocResource from '../../resources/custom_doc'
import CustomDocFieldResource from '../../resources/custom_doc_field'
import StateResource from '../../resources/state'
// components&views
import EntitiesGrid from '../../components/entities_grid/EntitiesGrid'
import CustomDocGrid from '../../components/CustomDocGrid.vue'
import CustomDocFieldsGrid from '../../components/CustomDocFieldsGrid.vue'
import FormResourceEdit from '../../components/form_resource_edit/FormResourceEdit.vue'
import AutoComplete from '../../components/Autocomplete.vue'
import CreateEntity from '../create_entity/CreateEntity.vue'
import CreateEditProjectLocation from '../../views/create_edit_project_location/CreateEditProjectLocation.vue'
// mixins
import toastMixin from '../../mixins/toast'
import modalMixin from '../../mixins/modal'
import entitiesFormSet, { parentCompanyFormSet, showNamesFormSet } from '../../resources/formsets/entities'
import projectLocationFormSet from '../../resources/formsets/project_location'
import agreementEntityFormSet from '../../resources/formsets/agreement_entity'

export default Vue.extend({
    data() {
        return {
            statesReady: false,
            locationData: new ProjectLocationResource(),
            userResource: null,
            userRolesResource: null,
            approverResource: null,
            companyResource: null,
            selectedProjectResource: null,
            selectedProjectRelated: {
                projectLocations: null,
                unionAgreements: null,
            },
            copiedProjectResource: null,
            newProjectResource: null,
            showSelectedProjectResource: null,
            showCopiedProjectResource: null,
            showNewProjectResource: null,
            newLocation: undefined,
            newAgreement: undefined,
            entityId: null, // Production company
            projectId: null, // Job/Show
            isSavingUser: false,
            isSavingUserRole: false,
            isSavingApprover: false,
            agGridClickedUserId: null,
            agGridClickedDepartmentId: null,
            recentlyCreatedUserId: null,
            userForm: false,
            userRoleForm: false,
            approverForm: false,
            iteration: 0,
            customDocIteration: 100,
            customDocFieldsIteration: 1000,
            customDocsRowData: null,
            selectedCustomDocFieldsResource: null,
            selectedCustomDocResource: null,
            selectedCustomDocName: '',
            selectedProjectName: '',
        }
    },
    mixins: [toastMixin, modalMixin],
    components: {
        EntitiesGrid,
        CustomDocGrid,
        CustomDocFieldsGrid,
        AutoComplete,
        CreateEntity,
        FormResourceEdit,
        CreateEditProjectLocation,
    },
    computed: {
        resources() {
            return {
                EntitiesResource,
                ProjectLocationResource,
                AgreementEntityResource,
                CustomDocResource,
                CustomDocFieldResource,
            }
        },
        formsets() {
            return {
                entitiesFormSet,
                parentCompanyFormSet,
                showNamesFormSet,
                projectLocationFormSet,
                agreementEntityFormSet,
            }
        },
    },
    methods: {
        editLocation(location) {
            this.locationData = location
            this.showModal('create-edit-project-location')
        },
        async selectProject(selectedResource) {
            if (selectedResource && selectedResource.id) {
                this.selectedProjectResource = selectedResource
                await selectedResource.resolveRelated()
            }
        },
        async selectCustomDoc(selectedResource) {
            if (selectedResource && selectedResource.id) this.selectedCustomDocResource = selectedResource
        },
        // selecting a production company/client
        async userSelectedResource(resource) {
            if (resource && resource.id) {
                await resource.resolveRelated()
                this.entityId = resource.id
                this.companyResource = resource
                this.agGridClickedUserId = null // removes user roles ag grid when new entity is selected
                this.iteration++
                this.selectedProjectResource = null
                this.selectedProjectRelated = {
                    projectLocations: null,
                    unionAgreements: null,
                }
                this.copiedProjectResource = null
                this.newProjectResource = null
                this.showSelectedProjectResource = null
                this.showCopiedProjectResource = null
                this.showNewProjectResource = null
            }
        },
        handleApproverRowClicked(approverResource) {
            if (approverResource && approverResource[0]) {
                this.agGridClickedUserId = approverResource[0].attributes.user_id
                this.agGridClickedDepartmentId = approverResource[0].attributes.department_id
            }
        },
        onCopySelectedProjectResource() {
            this.copiedProjectResource = new EntitiesResource()
            const skippedAttributes = ['id', 'name', 'name_legal', 'name_reports', 'default_location_id', 'time_added']
            for (const attr in this.selectedProjectResource.attributes) {
                if (skippedAttributes.includes(attr)) continue
                this.copiedProjectResource.attributes[attr] = this.selectedProjectResource.attributes[attr]
            }
            this.showCopiedProjectResource = !this.showCopiedProjectResource
        },
        async onShowSelectedProjectResource() {
            const projectLocations = await ProjectLocationResource.list({ query: { entity_id: this.selectedProjectResource.id } })
            this.selectedProjectRelated.projectLocations = projectLocations.resources

            const unionAgreements = await AgreementEntityResource.list({ query: { entity_id: this.selectedProjectResource.id } })
            this.selectedProjectRelated.unionAgreements = unionAgreements.resources

            this.showSelectedProjectResource = !this.showSelectedProjectResource
        },
        async onShowSelectedCustomDocResource() {
            // to avoid confusion to users. when we change entity, will disappear customDoc and fields grid while retrieve new data
            if (this.selectedCustomDocFieldsResource) this.selectedCustomDocFieldsResource = ''
            if (this.selectedCustomDocResource) this.selectedCustomDocResource = ''
            if (this.customDocsRowData) this.customDocsRowData = ''

            let customDocs = this.selectedProjectResource.wrap('/customForms')
            let entityCustomDocs = await customDocs.get()
            let { data } = entityCustomDocs
            let customResource = []
            for (let result of data.results) {
                let resource = await this.resources.CustomDocResource.detail(result.id)
                customResource.push(resource)
            }
            this.customDocsRowData = customResource
            this.selectedProjectName = this.selectedProjectResource.attributes.name
        },
        async onShowSelectedCustomDocFields() {
            if (this.selectedCustomDocResource) {
                this.selectedCustomDocName = this.selectedCustomDocResource.attributes.name
                const fields = await CustomDocFieldResource.list({ query: { custom_document_id: this.selectedCustomDocResource.id } })
                this.selectedCustomDocFieldsResource = fields.resources
            } else {
                this.createToast('b-toaster-top-center', 'warning', true, 'Warning', 'No Selected Data')
            }
        },
        onCreateProjectResource() {
            this.newProjectResource = new EntitiesResource()
            const skippedAttributes = ['id', 'name', 'name_legal', 'name_reports', 'default_location_id', 'time_added']
            for (const attr in this.companyResource.attributes) {
                if (skippedAttributes.includes(attr)) continue
                this.newProjectResource.attributes[attr] = this.companyResource.attributes[attr]
            }
            this.newProjectResource.set('entity_type_id', 2)
            this.newProjectResource.set('parent_id', this.companyResource.id)
            this.newProjectResource.set('default_overtime_id', 5)
            this.newProjectResource.set(
                'other_properties',
                JSON.stringify({
                    showBatches: false,
                    showProjects: false,
                    showAccounts: false,
                    enableLoanoutsEmployee: false,
                    showAllocation: false,
                    accountString: {
                        account: true,
                        fringe: false,
                        series: false,
                        location: false,
                        set: false,
                        freeField: false,
                    },
                    allowNegativeAccrual: false,
                    allowedUnionRuleCollections: false,
                    allowedNonUnionRuleCollections: false,
                    sendNotificationsWithCompanyName: false,
                    overrideMPs: false,
                    hideMissingTimecards: false,
                    employeeAllowancesLocked: false,
                    defaultCurrency: 1,
                    defaultLegislativeType: null,
                    custom_form_allowed_signatures: null,
                    disableLoanouts: false,
                })
            )
            this.showNewProjectResource = !this.showNewProjectResource
        },
        onAddNewLocation() {
            this.locationData = new ProjectLocationResource()
            this.locationData.set('default', 0)
            this.locationData.set('country_id', 1)
            this.locationData.set('status', 1)
            this.showModal('create-edit-project-location')
        },
        async onSaveNewLocation() {
            const newLocationId = await this.$refs['newLocation'].onSubmit()
            if (this.newLocation.attributes.default === '1') {
                this.selectedProjectResource.set('default_location_id', newLocationId)
                this.selectedProjectResource.save()
            }
        },
        onAddNewAgreement() {
            this.newAgreement = new AgreementEntityResource()
            this.newAgreement.set('entity_id', this.selectedProjectResource.id)
            this.newAgreement.set('status', 1)
        },
        async onAddNewShow() {
            if (this.copiedProjectResource) {
                await this.$refs['copiedProjectResourceNameEdit'].onSubmit()
                this.selectedProjectResource = this.copiedProjectResource
                this.copiedProjectResource = undefined
            } else if (this.newProjectResource) {
                await this.$refs['newProjectResourceNameEdit'].onSubmit()
                this.selectedProjectResource = this.newProjectResource
                this.newProjectResource = undefined
            }
            this.showCopiedProjectResource = false
            this.showNewProjectResource = false
            this.onShowSelectedProjectResource()
        },
        async onSaveNewAgreement() {
            await this.$refs['newAgreement'].onSubmit()
            const unionAgreements = await AgreementEntityResource.list({ query: { entity_id: this.selectedProjectResource.id } })
            this.selectedProjectRelated.unionAgreements = unionAgreements.resources
            this.newAgreement = undefined
        },
        async onSaveShow() {
            await this.$refs['selectedProjectResourceNameEdit'].onSubmit()
        },
        onShowCustomDocDetail() {
            this.isShowCustomDocDetail = true
        },
        displayNewEntityForm() {
            this.showModal('create-entity')
        },
    },
    async mounted() {
        const state = await StateResource.list()
        this.states = state.resources
        this.statesReady = true
    },
})
</script>

<template>
    <div class="pageStyling">
        <h2>Enter a Company name</h2>
        <div class="autocompleteContainer">
            <auto-complete
                name="entities"
                placeholder="Enter a Company"
                :resource-class="resources.EntitiesResource"
                @select="userSelectedResource($event)"
                :filterOptions="{ entity_type_id: 1 }"
                :resolve-managers="['state_id']"
            >
                <template slot="item" slot-scope="option">
                    <p v-if="option.item.resource && option.item.resource.managers.user_id && option.item.resource.managers.user_id.resolved">{{ option.item.name }}</p>
                </template>
            </auto-complete>
            <create-entity v-if="statesReady" :states="states"></create-entity>
            <b-button class="mt-3" @click="displayNewEntityForm()">Add New Company</b-button>
        </div>
        <div v-if="selectedProjectResource" class="pageStyling">
            <h2>Selected Project</h2>
            {{ selectedProjectResource.attributes.name }}
            <div class="buttonContainer">
                <b-button @click="onShowSelectedProjectResource" :disabled="showCopiedProjectResource || showNewProjectResource">Show Selected Detail</b-button>
                <b-button @click="onCopySelectedProjectResource" :disabled="showSelectedProjectResource || showNewProjectResource">Copy Selected</b-button>
                <b-button href="/">Add Users</b-button>
                <b-button @click="onShowSelectedCustomDocResource">View Custom Docs</b-button>
            </div>
            <div v-if="showSelectedProjectResource && selectedProjectResource">
                <b-card class="mb-2" title="Edit Job/Show">
                    <b-card-text>
                        <b-row class="px-4 pb-2">
                            <div class="px-0 col-sm-9">
                                <form-resource-edit :resourceInstance="selectedProjectResource" :fieldSet="formsets.showNamesFormSet" ref="selectedProjectResourceNameEdit" />
                            </div>
                        </b-row>
                        <b-row class="px-4 pb-2">
                            <b-button class="m-1" @click="onSaveShow">Save Job/Show</b-button>
                        </b-row>
                    </b-card-text>
                </b-card>
                <b-card class="mb-2" title="Locations">
                    <b-card-text>
                        <b-row class="px-4 pb-2">
                            <div v-for="location in selectedProjectRelated.projectLocations" :key="location.id" class="px-0 col-sm-9">
                                <b-button class="m-1" @click="editLocation(location)">Show/Hide &ldquo;{{ location.attributes.name }}&rdquo;</b-button>
                            </div>
                        </b-row>
                        <b-row class="px-4 pb-2">
                            <b-button @click="onAddNewLocation()" class="m-1">Add New Location</b-button>
                        </b-row>
                    </b-card-text>
                </b-card>
                <create-edit-project-location
                    v-if="locationData && selectedProjectResource"
                    :resource="locationData"
                    :states="states"
                    :entity-id="selectedProjectResource.attributes.id"
                    :entity-name="selectedProjectResource.attributes.name"
                ></create-edit-project-location>
                <b-card class="mb-2" title="Agreements">
                    <b-card-text>
                        <b-row class="px-4 pb-2">
                            <div v-for="(agreement, ind) in selectedProjectRelated.unionAgreements" :key="agreement.id" class="px-0 col-sm-9">
                                <form-resource-edit :resourceInstance="agreement" :fieldSet="formsets.agreementEntityFormSet" :ref="'agreement_' + ind" />
                                <b-button class="m-1" @click="$refs['agreement_' + ind][0].onSubmit()">Save</b-button>
                            </div>
                        </b-row>
                        <b-row class="px-4 pb-2">
                            <b-button v-b-toggle="'newAgreement'" @click="onAddNewAgreement" class="m-1">Add New Agreement</b-button>
                        </b-row>
                        <b-row class="px-4">
                            <b-collapse :id="'newAgreement'">
                                <form-resource-edit :resourceInstance="newAgreement" :fieldSet="formsets.agreementEntityFormSet" :ref="'newAgreement'" />
                                <b-button class="m-1" @click="onSaveNewAgreement">Save New Agreement</b-button>
                                <b-button v-b-toggle="newAgreement" class="m-1">Hide New Agreement</b-button>
                            </b-collapse>
                        </b-row>
                    </b-card-text>
                </b-card>
                <b-card class="mb-2" title="Production Company Info">
                    <b-card-text>
                        <b-button v-b-toggle="'copied-parent'" class="m-1">Show/Hide Production Company Info</b-button>
                        <b-collapse id="copied-parent">
                            <b-row class="px-4 pb-2">
                                <div class="px-0 col-sm-9">
                                    <form-resource-edit :resourceInstance="selectedProjectResource" :fieldSet="formsets.parentCompanyFormSet" ref="selectedProjectResourceParentEdit" />
                                </div>
                            </b-row>
                            <b-row class="px-4 pb-2">
                                <b-button class="m-1" @click="onSaveShow">Save Job/Show</b-button>
                            </b-row>
                        </b-collapse>
                    </b-card-text>
                </b-card>
            </div>
            <div v-if="showCopiedProjectResource && selectedProjectResource">
                <b-card class="mb-2" title="Create New Job/Show">
                    <b-card-text>
                        <b-row class="px-4 pb-2">
                            <div class="px-0 col-sm-9">
                                <form-resource-edit :resourceInstance="copiedProjectResource" :fieldSet="formsets.showNamesFormSet" ref="copiedProjectResourceNameEdit" />
                            </div>
                        </b-row>
                        <b-button class="m-1" @click="onAddNewShow">Add New Job/Show</b-button>
                    </b-card-text>
                </b-card>
                <b-card class="mb-2" title="Production Company Info">
                    <b-card-text>
                        <b-button v-b-toggle="'copied-parent'" class="m-1">Show/Hide Production Company Info</b-button>
                        <b-collapse id="copied-parent">
                            <b-row class="px-4 pb-2">
                                <div class="px-0 col-sm-9">
                                    <form-resource-edit :resourceInstance="copiedProjectResource" :fieldSet="formsets.parentCompanyFormSet" ref="copiedProjectResourceParentEdit" />
                                </div>
                            </b-row>
                        </b-collapse>
                    </b-card-text>
                </b-card>
            </div>
        </div>
        <div class="mt-3" v-else-if="companyResource && !selectedProjectResource">
            Select a show below OR <a class="fake-link" @click="onCreateProjectResource" :disabled="showSelectedProjectResource || showCopiedProjectResource">Create New Project</a>
            {{ `for: ${companyResource.attributes.name} / ProHire ID: ${companyResource.attributes.id} / ProPay ID: ${companyResource.attributes.propay_id}` }}
            <div v-if="showNewProjectResource">
                <b-card title="Create New Job/Show">
                    <b-card-text>
                        <b-row class="px-4 pb-2">
                            <div class="px-0 col-sm-9">
                                <form-resource-edit :resourceInstance="newProjectResource" :fieldSet="formsets.showNamesFormSet" ref="newProjectResourceNameEdit" />
                            </div>
                        </b-row>
                        <b-button class="m-1" @click="onAddNewShow">Add New Job/Show</b-button>
                    </b-card-text>
                </b-card>
                <b-card class="mb-2" title="Production Company Info">
                    <b-card-text>
                        <b-button v-b-toggle="'copied-parent'" class="m-1">Show/Hide Production Company Info</b-button>
                        <b-collapse id="copied-parent">
                            <b-row class="px-4 pb-2">
                                <div class="px-0 col-sm-9">
                                    <form-resource-edit :resourceInstance="newProjectResource" :fieldSet="formsets.parentCompanyFormSet" ref="copiedProjectResourceParentEdit" />
                                </div>
                            </b-row>
                        </b-collapse>
                    </b-card-text>
                </b-card>
            </div>
        </div>
        <entities-grid v-if="entityId" :entityId="entityId" :key="iteration" class="ag-theme-balham agGrid" @select="selectProject" />
        <custom-doc-grid
            v-if="customDocsRowData"
            :row-data="customDocsRowData"
            :key="customDocIteration"
            class="ag-theme-balham agGrid"
            @select="selectCustomDoc"
            @showCustomDocFields="onShowSelectedCustomDocFields"
            :selectedProjectName="this.selectedProjectName"
        />
        <custom-doc-fields-grid
            v-if="selectedCustomDocFieldsResource"
            :row-data="selectedCustomDocFieldsResource"
            :key="customDocFieldsIteration"
            :selectedCustomDocName="this.selectedCustomDocName"
            :selectedCustomDocId="this.selectedCustomDocResource.id"
            class="ag-theme-balham agGrid"
        />
    </div>
</template>

<style scoped>
.fake-link {
    text-decoration: underline;
    color: blue;
}

.pageStyling {
    margin: 50px 0px 0px 25px;
}

.autocompleteContainer {
    width: 25%;
}

.agGrid {
    margin: 50px 0px 0px 0px;
}

.buttonContainer {
    display: flex;
    margin-top: 20px;
}

.buttonContainer > * {
    margin-right: 20px;
}
</style>
